import { Investment } from './Investment';
import { Member } from './Member';

export enum CollaboratorPermissionType {
    VIEW = 'View', // Read
    COMMENT = 'Comment', // "Update"
    EDIT = 'Edit', // Create, Delete
    OWNER = 'Owner', // Full-access (whoever created the investment)
}

export enum CollaboratorStatusType {
    PENDING = 'Pending',
    ACTIVE = 'Active',
    DEACTIVATED = 'Deactivated',
    BLOCKED = 'Blocked',
}


export interface Collaborator {
  id: string;
  investment: Investment;
  member: Member;
  permission: CollaboratorPermissionType | undefined;
  status: CollaboratorStatusType | undefined;
  createdAt: Date;
  updatedAt: Date;
}
